import {isNull} from "@/utils/formatting";

export default {
    methods: {
        createEmptyObjectFromFields(fields) {
            let emptyObject = {};
            for (let field in fields) {
                if (field !== 'id') {
                    let value;
                    if (!isNull(fields[field].default)) {
                        value = fields[field].default;
                    } else {
                        if (fields[field].type === 'string'
                            || fields[field].type === 'field'
                            || fields[field].type === 'choice') {
                            value = '';
                        } else if (fields[field].type === 'list'
                            || fields[field].type === 'multiple choice') {
                            value = [];
                        }
                    }
                    emptyObject[field] = value;
                }
            }
            return emptyObject;
        },
    },
};
